import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "@/App";
import { queryClient } from "@/config/query-client";
import { initAppVersion } from "@/app-version";
import "@fontsource-variable/figtree";
import { initConfigFromJson } from "@/config";
import "@/shared/styles/globals.css";

initAppVersion();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element not found. Make sure there is a <div id='root'></div> in your HTML."
  );
}

async function bootstrap(container: HTMLElement): Promise<void> {
  await initConfigFromJson();
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
          <App />
      </QueryClientProvider>
    </StrictMode>
  );
}

void bootstrap(rootElement);
